import AppNavbar from "@/components/common/AppNavbar";
import Breadcrumbs from "@/components/common/Breadcrumbs";
import RestaurantRegistrationForm from "@/components/forms/RestaurantRegistrationForm";

export default function RegisterRestaurant() {
  return (
    <>
      <AppNavbar />
      <div className="bg-base-100 pt-16">
        <Breadcrumbs />
        <div className="flex min-h-screen flex-col items-center bg-base-200 px-4 py-6 sm:p-6">
          <h1 className="mb-4 text-xl font-bold sm:mb-6 sm:text-2xl">
            Restaurant Registration
          </h1>
          <div className="w-full max-w-4xl rounded-lg bg-base-100 p-4 shadow sm:p-6 lg:p-8">
            <RestaurantRegistrationForm />
          </div>
        </div>
      </div>
    </>
  );
}
